import {
  CREATE_DELIVERY_FAILURE,
  CREATE_DELIVERY_REQUEST,
  CREATE_DELIVERY_SUCCESS,
  DELIVERIES_SIGN_OUT_FAILURE,
  DELIVERIES_SIGN_OUT_REQUEST,
  DELIVERIES_SIGN_OUT_SUCCESS,
  GET_DELIVERY_LIST_FAILURE,
  GET_DELIVERY_LIST_REQUEST,
  GET_DELIVERY_LIST_SUCCESS,
  GET_ITEMS_FOR_EXPORT_SUCCESS,
  UPDATE_DELIVERY_FAILURE,
  UPDATE_DELIVERY_REQUEST,
  UPDATE_DELIVERY_SUCCESS,
} from '../../actionConstants';

import { sendGA4Event } from '../Shared/utils/ga';

import apiClient from '../../apiClient';

export const createDelivery = (
  dispatch,
  { isGeneralDelivery, ...data },
  callback,
  successMessage,
) =>
  dispatch({
    type: CREATE_DELIVERY_REQUEST,
    isForm: true,
    payload: apiClient.callCenter[
      isGeneralDelivery ? 'createGeneralDelivery' : 'createDelivery'
    ](data).then(
      (res) => {
        dispatch({
          type: CREATE_DELIVERY_SUCCESS,
          successMessage,
        });
        sendGA4Event('created_delivery');
        return callback(res);
      },
      (err) =>
        dispatch({
          type: CREATE_DELIVERY_FAILURE,
          err,
        }),
    ),
  });

export const getDeliveries = (dispatch, queryParams, isExport) =>
  dispatch({
    type: GET_DELIVERY_LIST_REQUEST,
    withoutLoading: isExport,
    isTodayCount: queryParams?.todayCount,
    payload: apiClient.deliveries.get(queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_DELIVERY_LIST_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        dispatch({ type: GET_DELIVERY_LIST_FAILURE, err });
        return err;
      },
    ),
  });

export const updateDelivery = (dispatch, deliveryId, data) =>
  dispatch({
    type: UPDATE_DELIVERY_REQUEST,
    payload: apiClient.deliveries.update(deliveryId, data).then(
      (res) => {
        dispatch({
          type: UPDATE_DELIVERY_SUCCESS,
          res,
        });
        return res;
      },
      (err) => dispatch({ type: UPDATE_DELIVERY_FAILURE, err }),
    ),
  });

export const deliveriesSignOut = (dispatch, data) =>
  dispatch({
    type: DELIVERIES_SIGN_OUT_REQUEST,
    payload: apiClient.deliveries.signOut(data).then(
      (res) => {
        dispatch({
          type: DELIVERIES_SIGN_OUT_SUCCESS,
          res,
        });
        return res;
      },
      (err) => dispatch({ type: DELIVERIES_SIGN_OUT_FAILURE, err }),
    ),
  });
